import routerOptions0 from "/opt/render/project/src/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  scrollBehaviorType: "auto",
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions0,
}